import { configureStore } from "@reduxjs/toolkit"
import sectionReducer from "./sectionSlice"
import preferencesReducer from "./preferencesSlice"
import versionReducer from "./versionSlice"
import featureTogglesReducer from "./featureTogglesSlice"

export const store = configureStore({
  reducer: {
    section: sectionReducer,
    preferences: preferencesReducer,
    version: versionReducer,
    featureToggles: featureTogglesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state for serialization checks
        ignoredPaths: ["preferences.tenantInformation"],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
